import { Injectable } from '@angular/core';
import { TransactionalService } from '../transactional.service';
import { Observable } from 'rxjs';
import { IResponse } from '../../../models/dtos/response.interface';
import { HttpParams } from '@angular/common/http';
import { IOrganizationExternalConnection } from '../../../models/dtos/get/organization-external-connection.interface';

@Injectable({
  providedIn: 'root',
})
export class GoogleCalendarService {
  constructor(private _transactionalService: TransactionalService) {}

  public getGoogleAuthorizationUrl(
    organizationId: string,
  ): Observable<IResponse<string>> {
    let params = new HttpParams().set('organizationId', organizationId);
    return this._transactionalService.get<IResponse<string>>(
      `connect-google-calendar?${params.toString()}`,
    );
  }

  public exchangeCode(
    code: string,
    state: string,
    userId: string,
  ): Observable<IResponse<IOrganizationExternalConnection>> {
    let params = new HttpParams()
      .set('code', code)
      .set('state', state)
      .set('userId', userId);

    return this._transactionalService.get<
      IResponse<IOrganizationExternalConnection>
    >(`google-calendar-callback?${params.toString()}`);
  }
}
